import { HTMLAttributes } from 'react'

import ScrollIcon from '@/components/base/ScrollIcon'
import Typography from '@/components/base/Typography'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'
import { WPPageData } from '@/types'

export type ScrollingIconProps = HTMLAttributes<HTMLElement> &
  Partial<{
    theme: WPPageData['acf']['hero']['theme']
  }>

const ScrollingIcon = ({
  className,
  theme = 'light',
  ...props
}: ScrollingIconProps) => {
  const { strings } = useStore()
  return (
    <div
      className={cn(['flex items-end gap-[1.6rem] opacity-50', className])}
      {...props}
    >
      <ScrollIcon theme={theme} />
      <Typography variant="small">{strings?.scroll_down_label}</Typography>
    </div>
  )
}

export default ScrollingIcon
